import { PersistenceLevel, Store } from '@/core/flux.service';
import { ActionBoard } from './actionBoard.types';

export class ActionBoardStore extends Store {
  persistenceLevel: PersistenceLevel = 'WORKSHEET';
  static readonly storeName = 'sqActionBoardStore';

  initialize() {
    this.state = this.immutable({
      boardId: undefined,
      board: undefined,
      refreshKey: 0,
    });
  }

  get refreshKey(): number {
    return this.state.get('refreshKey');
  }

  get boardId(): string | undefined {
    return this.state.get('boardId');
  }

  get board(): ActionBoard | undefined {
    return this.state.get('board');
  }

  dehydrate(): { boardId?: string } {
    return {
      boardId: this.state.get('boardId'),
    };
  }

  rehydrate(dehydratedState: { boardId?: string }) {
    if (dehydratedState.boardId) {
      this.state.set('boardId', dehydratedState.boardId);
    }
  }
  protected readonly handlers = {
    ACTION_BOARD_SET_BOARD_ID: (payload: { boardId: string }) => {
      this.state.set('boardId', payload.boardId);
      console.log('set boardId', payload.boardId);
    },

    ACTION_BOARD_SET_BOARD: (payload: { board: ActionBoard }) => {
      this.state.set('board', payload.board);
      this.state.set('boardId', payload.board.id);
    },

    ACTION_BOARD_REFRESH: (payload: { refreshKey: number }) => {
      this.state.set('refreshKey', payload.refreshKey);
    },
  };
}
